import React, { PureComponent } from 'react'
import { Button, Skeleton, Tabs, Checkbox } from 'antd'
import classNames from 'classnames'
import styles from './index.less'

import { WhatsappIcon, WhatsappShareButton } from 'react-share'
import MiniTimer from '../Timer/MiniTimer'
import TimerMini from '../Timer/TimerMini'

const { TabPane } = Tabs

export default class PageHeader extends PureComponent {
    componentDidMount() {
        // Wait 4 seconds, then click submenu arrows and scroll/focus
        setTimeout(() => {
            const parentArrow = document.querySelector(
                '.ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-arrow'
            );
            if (parentArrow) {
                parentArrow.click();

                const parentSubmenu = parentArrow.closest('li.ant-menu-submenu-selected');
                if (parentSubmenu) {
                    const container = document.querySelector('.ant-menu-inline, .ant-menu-root');
                    if (container) {
                        const containerTop = container.getBoundingClientRect().top;
                        const itemTop = parentSubmenu.getBoundingClientRect().top;
                        const scrollTop = container.scrollTop + (itemTop - containerTop - 100); // extra scroll offset
                        container.scrollTo({ top: scrollTop, behavior: 'smooth' });
                    }
                }

                setTimeout(() => {
                    const childArrow = document.querySelector(
                        '.ant-menu-submenu-selected > ul .ant-menu-submenu-selected > .ant-menu-submenu-title .ant-menu-submenu-arrow'
                    );

                    if (childArrow) {
                        childArrow.click();

                        setTimeout(() => {
                            const childSubmenu = childArrow.closest('li.ant-menu-submenu-selected');
                            if (childSubmenu) {
                                const container = document.querySelector('.ant-menu-inline, .ant-menu-root');
                                if (container) {
                                    const containerTop = container.getBoundingClientRect().top;
                                    const itemTop = childSubmenu.getBoundingClientRect().top;
                                    const scrollTop = container.scrollTop + (itemTop - containerTop - 150); // more scroll offset
                                    container.scrollTo({ top: scrollTop, behavior: 'smooth' });
                                }
                                childSubmenu.focus({ preventScroll: true });
                            }
                        }, 400);
                    }
                }, 600);
            }
        }, 4000);

    }

    onChange = key => {
        const { onTabChange } = this.props
        if (onTabChange) {
            onTabChange(key)
        }
    }

    render() {
        const {
            title,
            logo,
            action,
            content,
            extraContent,
            tabList,
            className,
            tabActiveKey,
            tabDefaultActiveKey,
            tabBarExtraContent,
            loading = false,
            wide = false,
            deskColor,
            followUpsCallback = false,
            subTitle = false
        } = this.props

        const clsString = classNames(styles.pageHeader, className)
        const activeKeyProps = {}
        if (tabDefaultActiveKey !== undefined) {
            activeKeyProps.defaultActiveKey = tabDefaultActiveKey
        }
        if (tabActiveKey !== undefined) {
            activeKeyProps.activeKey = tabActiveKey
        }

        return (
            <div className={clsString}>
                <div className={wide ? styles.wide : ''}>
                    <Skeleton
                        loading={loading}
                        title={false}
                        active
                        paragraph={{ rows: 3 }}
                        avatar={{ size: 'large', shape: 'circle' }}>
                        <div className={styles.detail}>
                            {logo && <div className={styles.logo}>{logo}</div>}
                            <div className={styles.main}>
                                <div className={styles.row}>
                                    <Button
                                        type="dashed"
                                        onClick={this.props.goBack}
                                        shape="circle"
                                        icon="arrow-left"
                                        style={{ marginRight: 10 }}
                                    />
                                    {title && (
                                        <h1 className={styles.title}>
                                            {title}{' '}
                                            {deskColor ? (
                                                <span
                                                    style={{
                                                        width: 50,
                                                        height: 5,
                                                        backgroundColor: deskColor,
                                                        color: deskColor
                                                    }}>
                                                    color
                                                </span>
                                            ) : null}
                                        </h1>
                                    )}
                                    {subTitle && <h3 className={styles.title}>{subTitle}</h3>}
                                    {followUpsCallback && (
                                        <div className={styles.followUpOver}>
                                            <Checkbox onChange={e => followUpsCallback(e.target.checked)}>
                                                {/* Follow Up Overdue */}
                                            </Checkbox>
                                        </div>
                                    )}
                                    {action && <div className={styles.action}>{action}</div>}
                                    <div>
                                        <TimerMini />
                                    </div>
                                </div>
                                <div className={styles.row}>
                                    {content && <div className={styles.content}>{content}</div>}
                                    {extraContent && (
                                        <div className={styles.extraContent}>{extraContent}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {tabList && tabList.length ? (
                            <Tabs
                                className={styles.tabs}
                                {...activeKeyProps}
                                onChange={this.onChange}
                                tabBarExtraContent={tabBarExtraContent}>
                                {tabList.map(item => (
                                    <TabPane tab={item.tab} key={item.key} />
                                ))}
                            </Tabs>
                        ) : null}
                    </Skeleton>
                </div>
            </div>
        )
    }
}
